import React from 'react';
import { useParams } from 'react-router-dom';
import content from '../data/content';

function TeamDetailPage() {
  const { teamId } = useParams();
  const team = content.teams[teamId];

  if (!team) {
    return (
      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
        <h1>チームが見つかりません</h1>
        <p>指定されたチームは存在しません。</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '100px 20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h1>{team.title}</h1>
      <img 
        src={team.image} 
        alt={team.title} 
        style={{ 
          width: '100%', 
          maxHeight: '400px', 
          objectFit: 'cover', 
          marginBottom: '30px',
          borderRadius: '8px'
        }} 
      />
      <div style={{ lineHeight: '1.8', fontSize: '16px' }}>
        {team.overview.split('\n').map((paragraph, index) => (
          <p key={index} style={{ marginBottom: '20px' }}>
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
}

export default TeamDetailPage;